import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main style={{ paddingTop: 72, minHeight: "calc(100vh - 72px)" }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
